(() => {
  if (customElements.get('rad-tech-navigator')) return;
  class RadTechNavigator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try {
        this.content = JSON.parse(this.querySelector('[data-config]').textContent);
        this.intent = 'choose';
        this.product = this.querySelector('[data-product]');
        this.search = this.querySelector('[data-search]');
        this.answers = Array.from(this.querySelectorAll('[data-tech-answer]'));
        this.contextCopy = this.querySelector('[data-context-copy]');
        this.defaultCopy = this.contextCopy.textContent;
        this.content.products.forEach(p => this.product.add(new Option(p.name, p.key)));
        this.querySelectorAll('[data-intent]').forEach(button => button.addEventListener('click', () => {
          this.intent = button.dataset.intent;
          this.querySelectorAll('[data-intent]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          this.render();
        }));
        this.product.addEventListener('change', () => { this.render(); });
        this.search.addEventListener('input', () => this.render());
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.product.value = ''; this.search.value = '';
          this.querySelector('[data-intent="choose"]').click(); this.product.focus();
        });
        this.querySelectorAll('[data-enhanced]').forEach(el => { el.hidden = false; });
        this.render();
        this.openLinkedAnswer();
        window.addEventListener('hashchange', () => this.openLinkedAnswer());
      } catch (error) { /* Server-rendered questions and links remain available. */ }
    }
    openLinkedAnswer() {
      const answer = this.answers.find(a => '#' + a.id === window.location.hash);
      if (!answer) return;
      this.product.value = answer.dataset.products.split(',')[0] || '';
      this.intent = answer.dataset.intents.split(',')[0];
      this.querySelectorAll('[data-intent]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.intent === this.intent)));
      this.search.value = ''; this.render(); answer.open = true;
    }
    guideUrl(p) {
      if (!p || !this.dataset.guideUrl) return '#product-guides';
      const url = new URL(this.dataset.guideUrl); url.searchParams.set('guide', p.guide); return url.href;
    }
    render() {
      const p = this.content.products.find(p => p.key === this.product.value);
      const words = this.search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      this.answers.forEach(answer => {
        const products = answer.dataset.products.split(',').filter(Boolean);
        const productMatches = p ? !products.length || products.includes(p.key) : words.length ? true : !products.length;
        const matches = productMatches && answer.dataset.intents.split(',').includes(this.intent) && words.every(w => answer.textContent.toLowerCase().includes(w));
        answer.hidden = !matches;
        if (!matches) answer.open = false;
        if (matches) count++;
        answer.querySelector('[data-question-support]').href = this.supportUrl(p, answer.querySelector('summary').textContent.trim());
      });
      const status = this.querySelector('[data-count]'); status.textContent = count + ' ' + (count === 1 ? status.dataset.singular : status.dataset.suffix);
      this.querySelector('[data-empty]').hidden = count > 0;
      this.contextCopy.textContent = p ? p.summary : this.defaultCopy;
      const guide = this.querySelector('[data-guide]'); guide.href = this.guideUrl(p);
      if (p && this.dataset.guideUrl) { guide.target = '_blank'; guide.rel = 'noopener'; } else { guide.removeAttribute('target'); }
      const link = this.querySelector('[data-product-link]'); link.href = p ? p.url : '/#finder';
      link.firstChild.textContent = (p ? this.content.labels.viewProduct : this.content.labels.finder) + ' ';
      this.querySelector('[data-support]').href = this.supportUrl(p, this.search.value);
    }
    supportUrl(p, question) {
      const l = this.content.labels;
      const button = this.querySelector('[data-intent="' + this.intent + '"]');
      const topic = Array.from(button.childNodes).filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent).join('').trim();
      const body = [l.product + ': ' + (p ? p.name : l.notSure), l.application + ': ' + l.notSure, l.topic + ': ' + topic, l.question + ': ' + (question || ''), '', l.donor, l.controller, l.symptom, l.photos].join('\r\n');
      return 'mailto:support@radesignsproducts.com?subject=' + encodeURIComponent('RAD support — ' + (p ? p.name : l.notSure)) + '&body=' + encodeURIComponent(body);
    }
  }
  customElements.define('rad-tech-navigator', RadTechNavigator);
})();
